import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { ElementType, ReactNode } from 'react';

import { Typography } from '../Typography/Typography';
import { TypographyIcon } from '../TypographyIcon/TypographyIcon';

export const Section = ({
  title,
  icon,
  action,
  'data-testid': dataTestId,
  children,
}: {
  title?: string;
  icon?: ElementType;
  action?: ReactNode;
  'data-testid'?: string;
  children: ReactNode;
}) => {
  return (
    <Box
      id="section"
      sx={({ palette }) => ({
        border: `1px solid ${palette.border.main}`,
        borderRadius: '8px',
        mx: 0,
      })}
    >
      {title ? (
        <Stack
          direction="row"
          data-testid={dataTestId}
          sx={[
            {
              alignItems: 'center',
              justifyContent: 'space-between',

              p: {
                sm: 3,
                xs: 2,
              },

              width: '100%',
            },
            ({ palette }) => ({
              backgroundColor: palette.background.default,
              borderBottom: `1px solid ${palette.border.main}`,
            }),
          ]}
        >
          {icon ? (
            <TypographyIcon icon={icon} color="default" variant="h5">
              {title}
            </TypographyIcon>
          ) : (
            <Typography color="default" variant="h5">
              {title}
            </Typography>
          )}

          <div>{action}</div>
        </Stack>
      ) : null}
      <Box
        sx={{
          background: 'white',
          p: {
            sm: 3,
            xs: 2,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
